import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { listsActions } from '$store/lists/index';
import { LoadListDataAction } from '$store/lists/interface';

function* loadLists() {
  try {
    const lists = yield call(Api, '/lists');
    yield put(listsActions.setLists(lists));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* loadListData(action: LoadListDataAction) {
  try {
    const listData = yield call(Api, `/lists/${action.payload}`);
    yield put(
      listsActions.setListData({
        listId: action.payload,
        listData,
      }),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* listsSaga() {
  yield all([
    takeLatest(listsActions.loadLists, loadLists),
    takeLatest(listsActions.loadListData, loadListData),
  ]);
}
